var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { isUndefined } from 'lodash';
import { connect } from 'react-redux';
import { useLoaderData } from 'react-router-dom';

import { acceptSuggestion, loadExtractor } from "./actions/actions";
import { EntitySuggestions } from "./EntitySuggestions";

import { ensure } from "../../shared/tsUtils";
import GeneralError from "../App/ErrorHandling/GeneralError";



const SuggestionComponent = ({
  templates,
  acceptSuggestion: acceptIXSuggestion,
  languages
}) => {
  const extractor = useLoaderData();
  let property;

  if (extractor) {
    const propertiesKey = extractor.property === 'title' ? 'commonProperties' : 'properties';
    property = templates.
    map((template) => {var _ensure$get;return (_ensure$get =
      ensure(template).
      get(propertiesKey)) === null || _ensure$get === void 0 ? void 0 : _ensure$get.
      find((p) => (p === null || p === void 0 ? void 0 : p.get('name')) === extractor.property);}
    ).
    filter((v) => !isUndefined(v));
  }

  if (property && property.size > 0) {var _property$get;
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
      _jsx(EntitySuggestions, {
        property: (_property$get = property.get(0)) === null || _property$get === void 0 ? void 0 : _property$get.toJS(),
        acceptIXSuggestion: acceptIXSuggestion,
        languages: languages === null || languages === void 0 ? void 0 : languages.toArray(),
        extractor: extractor }
      )
      ));

  }
  return /*#__PURE__*/(
    _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
    _jsx(GeneralError, {})
    ));

};

const mapStateToProps = (state) => ({
  templates: state.templates,
  languages: state.settings.collection.get('languages')
});

const mapDispatchToProps = {
  acceptSuggestion
};

const connector = connect(mapStateToProps, mapDispatchToProps);





export const IXSuggestions = connect(mapStateToProps, mapDispatchToProps)(SuggestionComponent);

export const IXSuggestionsLoader =
(headers) =>
async ({ params: { extractorId } }) => {
  const extractors = await loadExtractor({ id: extractorId }, headers);
  return extractors[0];
};